export const SIGNED_OUT_REASON_KEY = 'meridian-signed-out-reason';

let authenticated = false;
let expired = false;
const listeners = new Set<() => void>();

function emit() {
  listeners.forEach((listener) => listener());
}

export function clearSignedOutReason() {
  try {
    sessionStorage.removeItem(SIGNED_OUT_REASON_KEY);
  } catch {
    // Storage can be unavailable (private mode); the note is best-effort.
  }
}

function setSession(isAuthenticated: boolean) {
  authenticated = isAuthenticated;
  clearSignedOutReason();
  if (expired) {
    expired = false;
    emit();
  }
}

export function markSessionAuthenticated() {
  setSession(true);
}

export function markSessionEnded() {
  setSession(false);
}

// A 401 before the user was ever signed in is the normal unauthenticated path, not an expiry.
export function notifySessionExpired() {
  if (!authenticated || expired) return;
  expired = true;
  emit();
}

export function rememberSessionExpired() {
  try {
    sessionStorage.setItem(SIGNED_OUT_REASON_KEY, 'expired');
  } catch {
    // Best-effort, as above.
  }
}

export function rememberSignInFailed() {
  try {
    sessionStorage.setItem(SIGNED_OUT_REASON_KEY, 'signin-failed');
  } catch {
    // Best-effort, as above.
  }
}

export type SignedOutReason = 'expired' | 'signin-failed';

export function readSignedOutReason(): SignedOutReason | null {
  try {
    const reason = sessionStorage.getItem(SIGNED_OUT_REASON_KEY);
    return reason === 'expired' || reason === 'signin-failed' ? reason : null;
  } catch {
    return null;
  }
}

export function subscribeSessionExpiry(onChange: () => void): () => void {
  listeners.add(onChange);
  return () => listeners.delete(onChange);
}

export function getSessionExpiredSnapshot(): boolean {
  return expired;
}
